module.exports = __webpack_public_path__ + "static/media/SinpassPrimaryButton.38555f58.svg";